// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonWithIcon_button__2oqZu"};